// extracted by mini-css-extract-plugin
module.exports = {"visual":"visual_visual__3TmG_","noImage":"visual_noImage__1KiTs","hasImage":"visual_hasImage__14Uy6"};